unable to read source [project]/nextapp/node_modules/googleapis-common/node_modules/gcp-metadata/src/index.ts